<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.class}`"
		:data-type="context.type"
	>
		<div class="custom-formulate-middle_name--input">
			<input
				id="custom-formulate-middle_name"
				v-model="context.model"
				type="text"
				v-bind="context.attributes"
				:disabled="checked"
				@blur="context.blurHandler"
			>
			<b-form-checkbox
				id="customFormulateMiddleName"
				v-model="checked"
				name="check-button"
				class="mr-1 custom-middle_name--checkbox"
				@change="(e) => context.rootEmit('onChangeSwitchMiddleName', e)"
			>
				Нет отчества
			</b-form-checkbox>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			checked: false,
		};
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-input[data-classification='text'] input {
    border: none !important;
}
.custom-control {
    min-height: 1.2rem;
}

.custom-formulate-middle_name--input {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid #949ABA !important;
}

.custom-middle_name--checkbox {
	width: 11rem;
	@include media-breakpoint-only(sm) {
		width: 12rem;
	}
	@include media-breakpoint-down(xs) {
		width: 17rem;
	}
}
</style>
